import { ChangeDetectionStrategy, Component, computed, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Icons } from '../ce-icon/ICONLIB';
import { CeIconComponent } from '../ce-icon/ce-icon.component';

export type StatusBoxState = 'error' | 'warning' | 'info' | 'unknown';

@Component({
    selector: 'ce-status-box',
    imports: [CommonModule, CeIconComponent],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ce-status-box.component.html',
    styleUrl: './ce-status-box.component.scss',
    host: {
        '[class]': '_computedClass()',
    }
})
export class CeStatusBoxComponent {
    state: InputSignal<StatusBoxState> = input.required();
    label: InputSignal<string> = input('');
    icon: InputSignal<keyof Icons | undefined> = input<keyof Icons | undefined>(undefined);

    _computedClass(): string {
        const classes = ['CeStatusBox'];
        classes.push(`CeStatusBox--${this.state()}`, this.label() === '' ? '': 'CeStatusBox--has-label ');
        return classes.join(' ');
    }

    statusBoxIcon = computed((): keyof Icons => {
        if (this.icon()) return this.icon() as keyof Icons;

        switch (this.state()) {
            case 'error':
                return 'error-3';
            case 'warning':
                return 'error-2';
            case 'info':
                return 'error-1';
            case 'unknown':
            default:
                return 'error-0';
        }
    });
}
